var React = require('react');

function Headphones (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M512 288v48a32 32 0 0 1-17.69 28.62l-14.37 7c0-1.19.06-2.38.06-3.58a111.64 111.64 0 0 0-32-78.37V288c0-105.87-86.13-192-192-192S64 182.13 64 288v1.63A111.64 111.64 0 0 0 32 368c0 1.2 0 2.39.06 3.58l-14.37-7A32 32 0 0 1 0 336v-48C0 146.5 114.52 32 256 32s256 114.52 256 256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M168 256h-24a112 112 0 0 0 0 224h24a24 24 0 0 0 24-24V280a24 24 0 0 0-24-24zm200 0h-24a24 24 0 0 0-24 24v176a24 24 0 0 0 24 24h24a112 112 0 0 0 0-224z","className":"fa-primary","key":2})]);
}

Headphones.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Headphones;

Headphones.default = Headphones;
